import type { CampaignEditorValidationIssue } from '../campaign-editor/helpers/campaign-editor-validation';

type CampaignCreateFooterUsageInput = {
  limit: number;
  usedCount: number;
};

export function getCampaignCreateFooterMessage({
  campaignItemSlotLimit,
  issue,
}: {
  campaignItemSlotLimit: number;
  issue?: CampaignEditorValidationIssue;
}) {
  if (issue) {
    switch (issue.section) {
      case 'campaign-info':
        return 'Complete the required campaign details before creating.';
      case 'tracking-items':
        if (issue.reason === 'limit-exceeded') {
          return `Stay within the ${campaignItemSlotLimit} item limit to continue.`;
        }
        return 'Add at least one creator or post URL before creating.';
      case 'creators':
        return 'Check the creator rows before creating this campaign.';
      case 'post-urls':
        return 'Check the post URL rows before creating this campaign.';
      default:
        return 'Complete the required campaign setup to continue.';
    }
  }

  return 'Ready to create. You can still refine campaign details before submitting.';
}

export function getCampaignCreateFooterUsageLabel({
  usedCount,
  limit,
}: CampaignCreateFooterUsageInput) {
  return `${usedCount} / ${limit} creators or post URLs`;
}
